import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BookOpen, Palette, Heart, Sparkles } from "lucide-react";
import PageHeader from "@/components/site/PageHeader";
import Footer from "@/components/site/Footer";

const upcoming = [
  { icon: BookOpen, label: "Family Reading Guides", note: "Coming soon" },
  { icon: Palette, label: "Printable Coloring Pages", note: "Coming soon" },
  { icon: Heart, label: "Prayer Cards", note: "Coming soon" },
  { icon: Sparkles, label: "Children's Activities", note: "Coming soon" },
];

export default function Resources() {
  return (
    <div className="min-h-screen bg-twilight text-cream" data-testid="resources-page">
      <PageHeader />
      <main className="mx-auto max-w-4xl px-6 py-20 md:px-10 md:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-14 text-center"
        >
          <p className="font-body text-sm uppercase tracking-[0.25em] text-gold">Free Resources</p>
          <h1 className="mt-3 font-display text-4xl font-bold text-cream md:text-6xl">Gifts for your family</h1>
          <p className="mx-auto mt-4 max-w-xl font-body text-lg text-slate-300">
            Simple, faith-filled tools to help you nurture your child's heart. New free resources are on the
            way — here's what's coming.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {upcoming.map((c, i) => (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              data-testid={`resource-upcoming-${i}`}
              className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-5"
            >
              <div className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-full bg-gold/15 text-gold">
                <c.icon className="h-5 w-5" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-body font-medium text-cream">{c.label}</p>
                <p className="font-body text-sm text-slate-400">{c.note}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <p className="mt-12 text-center font-body text-slate-400">
          Want to be first to know when new resources drop?{" "}
          <Link to="/#free-gift" className="text-gold underline-offset-4 hover:underline">
            Join our list
          </Link>
          .
        </p>
      </main>
      <Footer minimal />
    </div>
  );
}
